<div class="flex h-full items-center justify-center">
    @if (token && username) {
        <div class="w-full rounded-lg bg-card shadow md:max-w-[512px]">
            <div class="flex w-full flex-col gap-6 px-8 py-8">
                <div class="flex flex-wrap items-center justify-end gap-2">
                    @if (commonService.darkModeService.get()) {
                        <app-button
                            tooltip="Light mode"
                            variant="link"
                            icon="faSolidSun"
                            (clicked)="commonService.darkModeService.toggle()" />
                    } @else {
                        <app-button
                            tooltip="Dark mode"
                            variant="link"
                            icon="faSolidMoon"
                            (clicked)="commonService.darkModeService.toggle()" />
                    }
                    <div placement="bottom-right" kendoTooltip title="{{ 'Change Language' | translate }}">
                        @if (commonService.i18nService.currentLanguage()) {
                            <kendo-dropdownbutton
                                buttonClass="bg-card text-card-foreground border-none transition-none hover:bg-primary/20 bg-none"
                                [data]="commonService.i18nService.languages">
                                {{ commonService.i18nService.currentLanguage().languageId | uppercase }}
                            </kendo-dropdownbutton>
                        }
                    </div>
                </div>

                <div class="flex flex-wrap items-center justify-center gap-2 text-2xl">
                    @if (logo) {
                        <img class="w-10" width="40" height="40" [ngSrc]="logo" />
                    }
                    <h1>{{ 'Reset Password' | translate }}</h1>
                </div>

                <div class="text-center text-muted">
                    @if (username) {
                        <div class="mb-2">
                            {{ 'Resetting password for' | translate }}:
                            <strong>{{ username }}</strong>
                        </div>
                    }
                    {{ 'Enter your new password below' | translate }}
                </div>

                <form class="flex flex-col gap-4">
                    <app-text-input
                        label="New Password"
                        id="newPassword"
                        [password]="true"
                        [passwordConditions]="true"
                        [isRequired]="true"
                        [isEditMode]="true"
                        [(value)]="newPassword" />

                    <app-text-input
                        label="Repeat New Password"
                        id="repeatNewPassword"
                        [password]="true"
                        [isRequired]="true"
                        [isEditMode]="true"
                        [(value)]="repeatNewPassword" />

                    @if (newPassword && repeatNewPassword && !passwordsMatch()) {
                        <div class="text-sm text-red-600">
                            {{ 'Passwords do not match' | translate }}
                        </div>
                    }

                    <div class="flex flex-col gap-4 text-center">
                        <app-button
                            class="w-full rounded-xl"
                            variant="primary"
                            [disabled]="!canSubmit()"
                            (clicked)="resetPassword()">
                            @if (isResetting) {
                                <span>{{ 'Resetting...' | translate }}</span>
                            } @else {
                                <span>{{ 'Reset Password' | translate }}</span>
                            }
                        </app-button>

                        <app-button class="w-full rounded-xl" variant="link" routerLink="/login">
                            {{ 'Back to Login' | translate }}
                        </app-button>
                    </div>
                </form>

                <div class="flex flex-wrap items-center justify-between gap-4 text-center text-muted">
                    <div>2025 &copy; {{ 'All rights reserved' | translate }}</div>
                    <div>{{ 'Version' | translate }} {{ version }}</div>
                </div>
            </div>
        </div>
    }
</div>
